import { route as Devices } from '../../main/devices/route.config.ts';
import { route as Home } from '../../main/home/route.config.ts';
import { route as Mine } from '../../main/mine/route.config.ts';
import { route as Reports } from '../../main/reports/route.config.ts';

import component from './page.vue';

const children = [Home, Reports, Devices, Mine];

export default {
  component,
  path: '/(home|devices|records|reports|mine)',
  children,
  name: 'main',
};
